import { HttpResponseError } from '@app/src/utils/validations';
import { hydrateUser } from './hydrators';
import { HttpStatus } from '@app/src/utils/validations/constants';
import axios from 'axios';
import { encrypt } from '../../helpers/encrypt';

export const serviceUser = {
  async login(values, url) {
    const encryptUsr = encrypt(values.username)
    const encryptedPwd = encrypt(values.password)
    try {
      const data = await axios.post(url, {
        username: encryptUsr,
        password: encryptedPwd
      });
      const refreshtoken = data.headers.authorization;
      localStorage.setItem('refreshtoken', refreshtoken);
      if (data.data.code === HttpStatus.LOGIN_ERROR) {
        return data.data;
      }
      return hydrateUser(data.data);
    } catch (error) {
      throw new HttpResponseError(error);
    }
  }
}
